import { ICategoryItem } from '../pages/home/categories/interfaces';
import { ICompany } from './companies';
import { ILocation } from './locations';

export interface IUserAddProps {
  login: string | undefined;
  email: string | undefined;
  password: string;
  roles: string[];
  first_name?: string;
  last_name?: string;
  middle_name?: string;
  countryCode?: string;
  phone?: string;
  phoneNumbers?: string;
  categoriesIds?: string | null;
  categories?: null;
  companyId?: number | string;
}

export interface IUserEditProps {
  login: string | undefined;
  email: string | undefined;
  password?: string;
  fio?: string | undefined;
  active?: boolean;
  locale?: string;
  first_name?: string;
  last_name?: string;
  middle_name?: string;
  role?: string;
  countryId?: number;
  country?: string;
  phoneNumbers?: string;
  countryCode?: string;
  companyId?: number | string;

}

export interface IUser {
  id: number;
  email: string;
  api_token: string;
  fio: string;
  login: string;
  is_admin: boolean;
  active: boolean;
  company: ICompany | null;
  roles: [UserRoleType];
  locale: string;
  location?: ILocation | null;
  phone: string;
  phone_numbers: string;
  first_name: string | null;
  last_name: string | null;
  middle_name: string | null;
  country?: any;
}

export enum UserRoles {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_MANAGER = 'ROLE_MANAGER',
  ROLE_USER = 'ROLE_USER',
  ROLE_VENDOR = 'ROLE_VENDOR',
  ROLE_BUYER = 'ROLE_BUYER',
  ROLE_VENDOR_STAFF = 'ROLE_VENDOR_STAFF',
  ROLE_BUYER_STAFF = 'ROLE_BUYER_STAFF',
}

export type UserRoleType =
  | 'ROLE_ADMIN'
  | 'ROLE_MANAGER'
  | 'ROLE_USER'
  | 'ROLE_VENDOR'
  | 'ROLE_BUYER'
  | 'ROLE_VENDOR_STAFF'
  | 'ROLE_BUYER_STAFF'

export enum LoginType {
  email = 'email',
  phone = 'phone',
  login = 'login',
}

export type TUserCountry = {
  code: string;
  en_name: string;
  id: number;
  mask: string;
  ru_name: string;
};
